var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateNotificacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 125,
    viewBox: "0 0 133 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.172 1.43656C106.639 -0.719124 102.838 -0.414275 100.682 2.11871C98.5256 4.65144 98.8312 8.45222 101.363 10.6087C113.495 20.936 120.452 35.9869 120.452 51.9022C120.452 55.2284 123.149 57.9249 126.475 57.9249C129.801 57.9249 132.498 55.2284 132.498 51.9022C132.498 32.4499 123.996 14.0562 109.172 1.43656Z",
    fill: "#D5DCEA",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.816 2.11909C29.6591 -0.414151 25.8578 -0.718742 23.3258 1.43771C8.50184 14.0576 -2.28882e-05 32.4508 -2.28882e-05 51.9023C-2.28882e-05 55.2285 2.69652 57.925 6.02268 57.925C9.34884 57.925 12.0454 55.2285 12.0454 51.9023C12.0454 35.9878 19.0031 20.9369 31.1344 10.6096C33.6669 8.45286 33.972 4.65182 31.816 2.11909Z",
    fill: "#D5DCEA",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.715 71.8251V45.2106C101.715 27.7064 88.9692 13.1259 72.2717 10.2573V6.02331C72.2717 2.69689 69.5751 0.000610352 66.2489 0.000610352C62.9228 0.000610352 60.2262 2.69663 60.2262 6.02331V10.2573C43.5284 13.1257 30.7819 27.7064 30.7819 45.2106L30.7819 71.8251C22.2715 74.4116 16.0602 82.3338 16.0602 91.678C16.0602 94.7837 16.7511 97.7295 17.9793 100.378L114.518 100.378C115.747 97.7295 116.437 94.7837 116.437 91.678C116.437 82.3338 110.226 74.4116 101.715 71.8251Z",
    fill: "#D5DCEA",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.217 112.423C51.7032 119.432 58.3974 124.468 66.249 124.468C74.1005 124.468 80.7945 119.432 83.2809 112.423H49.217Z",
    fill: "#D5DCEA",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateNotificacao);
export default __webpack_public_path__ + "static/media/empty-state-notificacao.9f0feaa4a209ad8b4fd5c28e4d0c4c90.svg";
export { ForwardRef as ReactComponent };